import * as colorManipulator from "@material-ui/core/styles/colorManipulator";
import * as estilos from "@material-ui/core/styles";

// O container roda @material-ui/core 4.12, onde fade e createMuiTheme avisam
// depreciacao, e a arvore instalada localmente ainda e 4.8, onde alpha e
// createTheme nao existem. Resolver em runtime mantem os dois ambientes.
export const alpha: (cor: string, valor: number) => string =
  (colorManipulator as any).alpha || (colorManipulator as any).fade;

export const createTheme: typeof estilos.createMuiTheme =
  (estilos as any).createTheme || (estilos as any).createMuiTheme;
